
import { AppService } from "app/services/app.service";
export abstract class AbConfigBiccateca extends AppService {
  abstract getConfigBiccateca();
  abstract getConfigMeuLocker();
  abstract getConfigPadrao();
  abstract salvar(entity: any);
}